import { render, staticRenderFns } from "./FilesRelated.vue?vue&type=template&id=5100bc1c&scoped=true&"
import script from "./FilesRelated.vue?vue&type=script&lang=js&"
export * from "./FilesRelated.vue?vue&type=script&lang=js&"
import style0 from "./FilesRelated.vue?vue&type=style&index=0&id=5100bc1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5100bc1c",
  null
  
)

export default component.exports